import { Zap, BarChart3, Settings } from 'lucide-react';
import { useState, useEffect } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { BoostDashboard } from '../components/BoostDashboard';
import { StatsDisplay } from '../components/StatsDisplay';
import { PerformanceGraph } from '../components/PerformanceGraph';
import { SettingsPanel } from '../components/SettingsPanel';
import { Card } from '../components/ui/card';

export default function Index() {
  const [activeTab, setActiveTab] = useState('boost');

  // Force dark mode
  useEffect(() => {
    document.documentElement.classList.add('dark');
  }, []);
  return (
    <div className="min-h-screen bg-black text-green-400">
      {/* Header */}
      <header className="sticky top-0 z-50 backdrop-blur-md bg-black/80 border-b border-green-700">
        <div className="max-w-md mx-auto px-4 py-6">
          <div className="flex items-center gap-3">
            <div className="p-3 rounded-lg bg-green-900">
              <Zap className="text-green-400" size={24} />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-green-400">FPS Booster</h1>
              <p className="text-xs text-green-600">Optimize your device performance</p>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-md mx-auto px-4 py-8 pb-24">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          {/* Tab Navigation */}
          <TabsList className="grid w-full grid-cols-3 mb-8 bg-green-900/50 border border-green-700">
            <TabsTrigger
              value="boost"
              className="data-[state=active]:bg-green-700 data-[state=active]:text-black gap-2 text-xs sm:text-sm"
            >
              <Zap size={18} />
              <span className="hidden sm:inline">Boost</span>
            </TabsTrigger>
            <TabsTrigger
              value="stats"
              className="data-[state=active]:bg-green-700 data-[state=active]:text-black gap-2 text-xs sm:text-sm"
            >
              <BarChart3 size={18} />
              <span className="hidden sm:inline">Stats</span>
            </TabsTrigger>
            <TabsTrigger
              value="settings"
              className="data-[state=active]:bg-green-700 data-[state=active]:text-black gap-2 text-xs sm:text-sm"
            >
              <Settings size={18} />
              <span className="hidden sm:inline">Settings</span>
            </TabsTrigger>
          </TabsList>

          {/* Boost Tab */}
          <TabsContent value="boost" className="space-y-6">
            <BoostDashboard />
          </TabsContent>

          {/* Stats Tab */}
          <TabsContent value="stats" className="space-y-6">
            {/* Performance Graph */}
            <Card className="p-4 backdrop-blur-sm border-green-700/30 bg-black/50">
              <h2 className="text-sm font-semibold text-green-400 mb-4">FPS History</h2>
              <PerformanceGraph />
            </Card>

            {/* Stats Cards */}
            <Card className="p-6 backdrop-blur-sm border-green-700/30 bg-black/50">
              <h2 className="text-lg font-semibold text-green-400 mb-4">Device Statistics</h2>
              <StatsDisplay />
            </Card>

            {/* Additional Info */}
            <Card className="p-4 backdrop-blur-sm border-green-700/30 bg-black/50">
              <h3 className="font-semibold text-green-400 mb-3">Performance Tips</h3>
              <ul className="space-y-2 text-sm text-green-600">
                <li>• Close unnecessary background apps</li>
                <li>• Reduce screen brightness for better battery</li>
                <li>• Use performance mode in settings</li>
                <li>• Clear cache regularly</li>
              </ul>
            </Card>
          </TabsContent>

          {/* Settings Tab */}
          <TabsContent value="settings" className="space-y-6">
            <Card className="p-6 backdrop-blur-sm border-green-700/30 bg-black/50">
              <h2 className="text-lg font-semibold text-green-400 mb-4">Preferences</h2>
              <SettingsPanel />
            </Card>

            {/* About Section */}
            <Card className="p-4 backdrop-blur-sm border-green-700/30 bg-black/50">
              <h3 className="font-semibold text-green-400 mb-3">About</h3>
              <div className="space-y-2 text-sm text-green-600">
                <p>FPS Booster v1.0.0</p>
                <p>Optimize your device performance with intelligent FPS boosting.</p>
              </div>
            </Card>
          </TabsContent>
        </Tabs>
      </main>

      {/* Footer - Safe Area for Mobile */}
      <div className="h-12 md:h-0" />
    </div>
  );
}